import React from "react";

import ContentCore from "../../../core/workingContent";

import "../_index.css";

const TaskProccessingUI = () => {
  return (
    <>
      <ContentCore />
    </>
  )
}

export default TaskProccessingUI;
